const VALID_SOURCES = new Set([
  'dashboard',
  'request-result',
  'share-invite-modal',
  'share-modal',
  'comment-email', // must come before email otherwise it will match on email since it matches earlier
  'email',
]);

export const getSanitizedRefererSource = (inviteSource: string | null) => {
  if (!inviteSource) return null;

  return (
    [...VALID_SOURCES].find((validSource) =>
      inviteSource.includes(validSource),
    ) || null
  );
};
